module.exports = __webpack_public_path__ + "static/img/062日式料理菜单.b6a86d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/062日式料理菜单.jpg
// module id = LcSo
// module chunks = 0